export enum ExplorationsActionType {
  LoadAllExplorations = '[Explorer] LoadAllExplorations',
  DeleteExplorationSuccess = '[Explorer] DeleteExplorationSuccess',
}
